import React from 'react';

import Chart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5, P } from '../../../AbstractElements';
import { CompanyOverviewTitle, Earning, LastYear } from '../../../Constant';
import { companyViewChart } from '../../../Data/DashBoard/Default/Chart';

const CompanyOverview = () => {
  return (
    <>
      <Col xl='8' md='6' className='box-col-50 xl-50'>
        <Card className='card company-view'>
          <CardHeader className='card-no-border d-flex flex-wrap justify-content-between p-b-0'>
            <H5 className='me-2'>{CompanyOverviewTitle}</H5>
            <div className='center-content mx-0 mx-xl-auto'>
              <P>
                {LastYear} $300K {Earning}
              </P>
            </div>
          </CardHeader>
          <CardBody className='card-body'>
            <Chart options={companyViewChart.options} series={companyViewChart.series} type='line' height={223} />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default CompanyOverview;
